const makeInitialState = () => ({
  contract: null,
  continueBilling: null
});

export default makeInitialState;
